/* eslint-disable no-unused-vars */
import { Grid } from "@mui/material";

import { withStyles } from "@mui/styles";

import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import PText from "../../components/pos/PText";
import PSelect from "../../components/pos/PSelect";
import { Typography } from "@mui/material";
import { Button } from "@mui/material";
import { red } from "@mui/material/colors";
import { StringUtils } from "../../utils/StringUtils";

const ColorButton = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(red[500]),
    backgroundColor: red[500],
    "&:hover": {
      backgroundColor: red[700],
    },
  },
}))(Button);

export default function POSummary(props) {
  const { t } = useTranslation();
  const translate = t;
  //const [totalQuantity, setQuantity] = useState(0);

  useEffect(() => {
    console.log("JT", props.context);
  }, [props.context]);

  return (
    <div style={{ paddingTop: "15px" }}>
      <Grid container>
        {!props.mobile && (props.poType == "GRN" || props.poType == "GRV") && (
          <Grid item xs={12} sm={1.5}>
            <PSelect
              options={props.discountTypeOptions}
              value={props?.summary?.discountType}
              label={"Discount type"}
              onChange={(event, newValue) => {
                props.updateSummaryValue("discountType", newValue);
              }}
            ></PSelect>
          </Grid>
        )}
        {!props.mobile && (props.poType == "GRN" || props.poType == "GRV") && (
          <Grid item xs={12} sm={1.5} style={{ paddingLeft: "10px" }}>
            <PText
              value={props.summary.discount}
              type="number"
              InputLabelProps={{ shrink: true }}
              label="Discount"
              onChange={(e) =>
                props.updateSummaryValue("discount", e.target.value)
              }
              disabled={props?.summary?.discountType?.id == 0}
            ></PText>
          </Grid>
        )}

        {!props.mobile && (props.poType == "GRN" || props.poType == "GRV") && (
          <Grid item xs={12} sm={1.5} style={{ paddingLeft: "10px" }}>
            <PText
              value={props.amount}
              error={props.errorAmount}
              onChange={(e) => props.setAmount(e.target.value)}
              //onChange={(e) => setInvoiceNumber(e.target.value)}
              InputLabelProps={{ shrink: true }}
              label="Invoice Amount"
            ></PText>
          </Grid>
        )}

        {!props.mobile && (
          <Grid
            item
            xs={12}
            sm={4}
            sx={{ marginTop: "0px", paddingLeft: "10px" }}
          >
            <table>
              <tbody>
                <tr>
                  <td>
                    <nobr>
                      <Typography variant="subtitle1" gutterBottom>
                        Qty :
                      </Typography>
                    </nobr>
                  </td>
                  <td>
                    <Typography variant="subtitle2" gutterBottom>
                      {props.summary.qty}
                    </Typography>
                  </td>
                  <td style={{ paddingLeft: "15px" }}>
                    <nobr>
                      <Typography variant="subtitle1" gutterBottom>
                        Net w/o tax :
                      </Typography>
                    </nobr>
                  </td>
                  <td>
                    <Typography variant="subtitle2" gutterBottom>
                      {props.summary.finalAmountExTax}
                    </Typography>
                  </td>
                  <td style={{ paddingLeft: "15px" }}>
                    <nobr>
                      <Typography variant="subtitle1" gutterBottom>
                        Net tax :
                      </Typography>
                    </nobr>
                  </td>
                  <td>
                    <Typography variant="subtitle2" gutterBottom>
                      {props.summary.finalTax}
                    </Typography>
                  </td>

                  <td></td>
                  {(props.poType == "GRN" || props.poType == "GRV") && (
                    <td style={{ paddingLeft: "15px" }}>
                      <nobr>
                        <Typography variant="subtitle1" gutterBottom>
                          Roundoff :
                        </Typography>
                      </nobr>
                    </td>
                  )}
                  {(props.poType == "GRN" || props.poType == "GRV") && (
                    <td>
                      <Typography variant="subtitle2" gutterBottom>
                        {props.roundoffAmount}
                      </Typography>
                    </td>
                  )}
                </tr>
              </tbody>
            </table>
          </Grid>
        )}

        {props.mobile && (
          <Grid item xs={8} sx={{ marginTop: "0px", paddingLeft: "10px" }}>
            <table>
              <tbody>
                <tr>
                  <td>
                    <nobr>
                      <Typography
                        variant="caption"
                        display="block"
                        gutterBottom
                      >
                        w/o tax :
                      </Typography>
                    </nobr>
                  </td>
                  <td>
                    <Typography variant="caption" display="block" gutterBottom>
                      {props.summary.finalAmountExTax}
                    </Typography>
                  </td>
                  <td>
                    <nobr>
                      <Typography
                        variant="caption"
                        display="block"
                        gutterBottom
                      >
                        tax :
                      </Typography>
                    </nobr>
                  </td>
                  <td>
                    <Typography variant="caption" display="block" gutterBottom>
                      {props.summary.finalTax}
                    </Typography>
                  </td>
                  <td style={{ width: "25px" }}></td>
                </tr>
              </tbody>
            </table>
          </Grid>
        )}

        {!props.mobile && (
          <Grid
            item
            xs={12}
            sm={props.poType == "GRN" || props.poType == "GRV" ? 3.5 : 8}
            style={{ textAlign: "right" }}
          >
            <Typography variant="h6" gutterBottom>
              Net total :{" "}
              {StringUtils.formattedNumberWithStoreDecimal(
                props.amount ? props.amount : 0,
                props.context
              )}
            </Typography>
          </Grid>
        )}

        {props.mobile && (
          <Grid
            item
            xs={4}
            sm={props.poType == "GRN" || props.poType == "GRV" ? 3.5 : 8}
            style={{ textAlign: "right" }}
          >
            <Typography variant="button" display="block" gutterBottom>
              total :{" "}
              {StringUtils.formattedNumberWithStoreDecimal(
                props.amount ? props.amount : 0,
                props.context
              )}
            </Typography>
          </Grid>
        )}
        <Grid
          item
          xs={6}
          sm={6}
          style={{ textAlign: "left", marginTop: "0px" }}
        >
          {!props.mobile &&
            props.showControls &&
            props.purchaseOrderObj &&
            props.context.privileges.grn_grv_delete &&
            (props?.purchaseOrderObj?.orderType == "GRN" ||
              props?.purchaseOrderObj?.orderType == "GRV") && (
              <ColorButton onClick={props.onDelete} variant="contained">
                DELETE
              </ColorButton>
            )}
          {!props.mobile &&
            props.showControls &&
            props.purchaseOrderObj &&
            props.context.privileges.lpo_lro_delete &&
            props?.purchaseOrderObj?.orderType == "LPO" && (
              <ColorButton onClick={props.onDelete} variant="contained">
                DELETE
              </ColorButton>
            )}
        </Grid>
        {!props.mobile && (
          <Grid
            item
            xs={6}
            sm={6}
            style={{ textAlign: "right", marginTop: "0px" }}
          >
            {props.showControls &&
              (props.mode == "edit" || props.mode == "create") &&
              (props.poType == "GRN" || props.poType == "GRV") &&
              (!props.purchaseOrderObj ||
                props?.purchaseOrderObj?.status == "DRAFT" ||
                props?.purchaseOrderObj?.status == "REQUESTED" ||
                (props?.purchaseOrderObj?.status == "SETTLED" &&
                  (props.context.privileges.grn_grv_settled_edit ||
                    (props?.purchaseOrderObj?.orderType == "LPO" &&
                      props.context.privileges.lpo_lro_settled_edit)))) && (
                <Button
                  onClick={props.onSave}
                  variant="contained"
                  color="primary"
                >
                  POST
                </Button>
              )}
            {props.showControls &&
              props.poType == "LPO" &&
              (!props.purchaseOrderObj ||
                props?.purchaseOrderObj?.status == "DRAFT" ||
                (props?.purchaseOrderObj?.status == "REQUESTED" &&
                  props.context.privileges.lpo_lro_requested_edit)) && (
                <Button
                  onClick={props.onSave}
                  variant="contained"
                  color="primary"
                >
                  CREATE
                </Button>
              )}
            {props.showControls &&
              props.poType == "LPO" &&
              (!props.purchaseOrderObj ||
                props?.purchaseOrderObj?.status != "SETTLED") && (
                <Button
                  onClick={props.onSaveAndPrint}
                  variant="contained"
                  color="primary"
                  sx={{ marginLeft: "10px" }}
                >
                  Create and Print
                </Button>
              )}
            {props.showControls &&
              ((props.context.privileges.grn_grv_draft_edit &&
                (props.poType == "GRN" || props.poType == "GRV")) ||
                (props.context.privileges.lpo_lro_draft_edit &&
                  props.poType == "LPO")) &&
              (!props.purchaseOrderObj ||
                props?.purchaseOrderObj?.status == "DRAFT" ||
                (props?.purchaseOrderObj?.status == "SETTLED" &&
                  props.context.privileges.grn_grv_settled_edit)) && (
                <Button
                  onClick={props.onSaveDraft}
                  variant="contained"
                  color="primary"
                  sx={{ marginLeft: "10px" }}
                >
                  Save Draft
                </Button>
              )}
          </Grid>
        )}
      </Grid>
    </div>
  );
}
